import React from "react";
import { BeatLoader } from "react-spinners";

export const UserLoader = () => {
  return <BeatLoader color="#fff" size={10} margin={2} />;
};
